export default "__VITE_ASSET__36fda4d0__"